import React, { createContext, useContext, useState, useEffect } from 'react';
import { useJsApiLoader } from '@react-google-maps/api';

const GoogleMapsContext = createContext();

const LIBRARIES = ["places", "maps"]; // 📌 Asegurar que las librerías sean las mismas en todo el proyecto

export const GoogleMapsProvider = ({ children }) => {
    const { isLoaded, loadError } = useJsApiLoader({
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY, // 📌 Asegúrate de que esta clave esté bien configurada en el .env
        libraries: LIBRARIES,
        language: 'es',
    });

    const [googleMaps, setGoogleMaps] = useState(null);

    useEffect(() => {
        if (isLoaded && window.google && window.google.maps) {
            setGoogleMaps(window.google.maps);
        }
    }, [isLoaded]);

    if (loadError) {
        console.error("❌ Error al cargar Google Maps API:", loadError);
        return <p>Error al cargar Google Maps</p>;
    }

    return (
        <GoogleMapsContext.Provider value={{ isLoaded, googleMaps }}>
            {children}
        </GoogleMapsContext.Provider>
    );
};

export const useGoogleMaps = () => {
    const context = useContext(GoogleMapsContext);
    if (!context) {
        throw new Error("useGoogleMaps debe usarse dentro de un GoogleMapsProvider");
    }
    return context;
};
